import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../api/context';
import toast from '../../utils/toast';
import wizard from '../../utils/wizard';
import Base from '../Base';
import styles from './Login.module.scss';

const Login = () => {

  const { setToken } = useAPIContext();
  const [ loading, setLoading ] = useState(false);

  const [ params ] = useSearchParams();

  const TARGET = '/campaigns';

  const target = params.get('target') || TARGET;
  const email = params.get('email');

  const navigate = useNavigate();

  return (
    <Base title='Creator Login'>
      <div className={styles.root}>
        <Formik
          initialValues={{
            email,
            password: '',
          }}
          validationSchema={yup.object({
            email: yup.string()
              .email('Invalid email address')
              .required('Email required'),
            password: yup.string()
              .required('Password required')
          })}
          onSubmit={(values, actions) => {

            if (loading) {
              return;
            }

            setLoading(true);

            api().v1.auth.login.post(values)
              .then(res => {
                setLoading(false);

                if (res.status === 200) {
                  actions.resetForm();
                  setToken(res.body.token);

                  /*
                   * Mark the session so that the campaigns page can
                   * route incomplete profiles to the wizard. Login
                   * itself stays instant for fully-set-up users.
                   */
                  wizard.markPostLogin();

                  navigate(target);
                }

                if (res.status === 400) {
                  toast.show(toast.KIND.ERROR, res.body);
                }
              })
              .catch(err => {
                setLoading(false);
                toast.show(toast.KIND.WARNING, err);
              });

          }} >

          <Form>
            <div>
              <Field
                aria-label='email'
                placeholder='Email'
                name='email'
                type='email'
                disabled={loading}
              />
              <ErrorMessage
                name='email'
                component='div'
              />
            </div>

            <div>
              <Field
                aria-label='password'
                placeholder='Password'
                name='password'
                type='password'
                disabled={loading}
              />
              <ErrorMessage
                name='password'
                component='div'
              />
            </div>

            <button
              aria-label='login'
              type='submit'
              disabled={loading}>

              Login

            </button>
          </Form>

        </Formik>

        <ul>
          <li>
            Forgot Password?
            &nbsp;
            <Link to={`?dialog=forgot`}>
              Reset now
            </Link>
          </li>

          <li>
            <Link to={`?dialog=signup`}>
              Create an account!
            </Link>
          </li>

          <li>
            <a href='https://forms.gle/xhakgu9kQnb283pf6'>
              Report an issue
            </a>
          </li>
        </ul>
      </div>
    </Base>
  );
};

export default Login;